import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { DsBannerModule, DsBannerState } from '@levelaccess/design-system';
import { IChatV2ComponentChunk } from '@shared/interfaces/ai-executor.interface';

@Component({
  selector: 'app-ai-chat-banner',
  template: `
    <ds-banner [title]="title" [state]="state" [showCloseButton]="false" [showIcon]="false">
      <div ds-banner-body>{{ description }}</div>
    </ds-banner>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DsBannerModule],
  standalone: true,
})
export class AiChatBannerComponent implements OnChanges {
  @Input() public chunk: IChatV2ComponentChunk;

  public title: string = '';
  public description: string = '';
  public state: DsBannerState = DsBannerState.info;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  public static serialize(data: Record<string, unknown>): string {
    const title = (data['title'] as string) ?? '';
    const description = (data['description'] as string) ?? '';

    return [title, description].filter(Boolean).join('\n');
  }

  public ngOnChanges(): void {
    const data = this.chunk?.data ?? {};
    this.title = (data['title'] as string) ?? '';
    this.description = (data['description'] as string) ?? '';

    const rawState = data['state'] as string;
    this.state =
      rawState && Object.values(DsBannerState).includes(rawState as DsBannerState)
        ? (rawState as DsBannerState)
        : DsBannerState.info;

    this.changeDetectorRef.detectChanges();
  }
}
